import { and, eq, isNotNull } from "drizzle-orm";
import { MenuItem } from "@mui/material";
import { useContext } from "react";

import { db } from "@/db/db.ts";
import { feed, item, permission } from "@/db/schema.ts";
import { ActionContext } from "@/models/ActionsProvider.tsx";

export default function ClearAllUnreads({
  workspaceMembershipId,
  closeContext,
}: {
  workspaceMembershipId: string;
  closeContext?: () => void;
}) {
  const { accountEvent } = useContext(ActionContext);

  const clearAllUnreadItems = async () => {
    const unreadFeedItems = await db
      .selectDistinct({ id: feed.id })
      .from(feed)
      .innerJoin(item, and(eq(feed.id, item.feedId), eq(item.unread, true)))
      .innerJoin(
        permission,
        and(
          eq(feed.id, permission.feedId),
          eq(permission.workspaceMembershipId, workspaceMembershipId),
          eq(permission.name, "read"),
          eq(permission.enabled, true),
        ),
      )
      .execute();

    for (const feedRecord of unreadFeedItems) {
      accountEvent("Marked Feed as Read", {
        feedId: feedRecord.id,
      });
    }
    closeContext();
  };

  return (
    <MenuItem disabled={false} aria-label="clear-all-unreads" onClick={() => clearAllUnreadItems()}>
      Clear All Unreads
    </MenuItem>
  );
}
